export default __webpack_public_path__ + "static/media/aurora.46b5b99d.png";